import { render, staticRenderFns } from "./order_product_list.vue?vue&type=template&id=8b6c6238&scoped=true"
import script from "./order_product_list.vue?vue&type=script&lang=js"
export * from "./order_product_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6c6238",
  null
  
)

export default component.exports